<body>
  <div *ngIf="!isLoading" class="card border-top-thick" role="main" aria-labelledby="title">
    <!-- PMI logo -->
    <div class="brand">
      <img src="pmi-logo.png" alt="PMI logo">
    </div>

    <h1 id="title">Welcome to <br />Data Auto Classification Advisor (DACA)</h1>
    <p class="subtitle">AI Powered Advisory Tool</p>

    <ng-container *ngIf="!enableLoginPart">
      <button class="btn reset anim-bg-gradient" (click)="openLoginPart()" type="button"
        aria-label="Standard Login Button">Get Started &nbsp;<i class="fa-solid fa-arrow-right"></i></button>
    </ng-container>

    <ng-container *ngIf="enableLoginPart">
      <form class="auth-form">

        <!-- Node -->
        <div class="field">
          <label for="node">Node</label>
          <mat-form-field appearance="outline">
            <mat-select id="nodeSelect" placeholder="Select Node" [(ngModel)]="selectedNode"
              (selectionChange)="onNodeSelect($event)" name="nodeselect" required>
              <mat-option [value]="'FEA'">FEA</mat-option>
              <mat-option [value]="'FCD'">FCD</mat-option>
              <mat-option [value]="'FCT'">FCT</mat-option>
              <mat-option [value]="'DPS'">DPS</mat-option>
              <mat-option [value]="'DPT'">DPT</mat-option>
              <mat-option [value]="'KR'">KR</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Environment -->
        <div class="field">
          <label for="env">Environment</label>
          <mat-form-field appearance="outline">
            <mat-select id="envSelect" placeholder="Select Environment" [(ngModel)]="selectedEnv"
              (selectionChange)="onEnvSelect($event)" name="envselect" required>
              <mat-option [value]="'DEV'">DEV</mat-option>
              <mat-option [value]="'QAS'">QAS</mat-option>
              <mat-option [value]="'PRD'">PRD</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <button class="btn reset anim-bg-gradient" [disabled]="isLoginButtonEnabled" (click)="loginRedirect()"
          type="button" aria-label="Standard Login Button">LOGIN &nbsp;<i class="fa-solid fa-arrow-right"></i></button>
        <div class="footer-links" aria-label="Helpful links">
          <a href="https://wiki.app.pconnect.biz/spaces/AUC/pages/1529875515/AutoClassifier+DACA+-+Help+Documentation+Guide" target="_blank" rel="noopener">
            <p class="hover-underline-animation left">Documentation</p>
          </a>
          <a href="https://wiki.app.pconnect.biz/spaces/AUC/pages/1529875515/AutoClassifier+DACA+-+Help+Documentation+Guide" target="_blank" rel="noopener">
            <p class="hover-underline-animation left">Support</p>
          </a>
        </div>
      </form>
    </ng-container>
  </div>

  <div *ngIf="isLoading" class="loader">
    <div class="loader-circle-11">
      <div class="arc"></div>
      <div class="arc"></div>
      <div class="arc"></div>
    </div>
    <br />
    <div class="loader-message">Please wait...</div>
  </div>
</body>
